import { Box, Button, CircularProgress, Grid, Input, InputAdornment, Paper, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, TextField, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';

// Icons
import {
    Delete,
    Edit,
    Label,
    Search as SearchIcon
} from '@material-ui/icons'
import config from "../../config";
import Widget from '../../components/Widget/Widget';
import useStyles from "./styles";
import { ReferralState, getReferralDatas, handleActiveStatusChange, handleDeleteReferralCode } from '../../context/ReferralCodeContext';
import moment from 'moment';
import alertify from 'alertifyjs';

const ReferralCodeManagement = (props) => {
    const classes = useStyles();
    const context = ReferralState();

    var [users, setBackUsers] = useState(
        context.AllReferralData
    );
    const [order, setOrder] = useState('desc')
    const [orderBy, setOrderBy] = useState('created_date')
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [searchVal, setSearchVal] = useState('');

    const handleActiveStatus = async (item) => {
        const reqData = {
            "code_id": item.id, "is_active": item.is_active == 1 ? 0 : 1
        }
        await handleActiveStatusChange(context.setAllReferralData, reqData);
        await getReferralDatas(context.setAllReferralData);
    }

    //Function to call when pagination value change
    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    };

    //Function to set value of rows per page
    const handleChangeRowsPerPage = event => {
        setRowsPerPage(parseInt(event.target.value, 10))
        setPage(0)
    };

    const onDeleteReferralCodeClick = async (item) => {
        alertify.confirm("Are you sure you want to delete this code?", async (status) => {
            if (status) {
                const reqData = {
                    code_id: item.id
                };
                await handleDeleteReferralCode(context.setAllReferralData, reqData);
                getReferralDatas(context.setAllReferralData);
            }
        });
    };

    const onEditReferralCodeClick = (e, item) => {
        e.preventDefault();
        props.history.push({
            pathname: process.env.PUBLIC_URL + '/app/referralcodes/addreferralcode',
            state: { id: item.id }
        });
    }

    useEffect(() => {
        getReferralDatas(context.setAllReferralData);
    }, []);

    useEffect(() => {
        context.AllReferralData.allReferralState && setBackUsers(context.AllReferralData.allReferralState)
    }, [context.AllReferralData.isLoaded]);

    return (
        <>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Widget inheritHeight>
                        <Grid container spacing={5}>
                            <Grid item md={4} xs={4} sm={4}>
                                <Box>
                                    <span className={classes.mainPageTitle}><b>Referral Code Management</b>
                                    </span>
                                </Box>
                            </Grid>
                            <Grid item md={4} xs={4} sm={4}></Grid>
                            <Grid md={4} xs={4} sm={4} style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", paddingRight: "40px" }}>
                                <Button
                                    onClick={() => {
                                        props.history.push({
                                            pathname: process.env.PUBLIC_URL + '/app/referralcodes/addreferralcode',
                                            // state: { user_id: user_id }
                                        })
                                    }}
                                    variant="contained"
                                    color="primary"
                                >
                                    Add new Referral
                                </Button>
                            </Grid>
                        </Grid>
                    </Widget>

                </Grid>
                {!context.AllReferralData.isLoaded ? (
                    <Box
                        display={"flex"}
                        justifyContent={"center"}
                        alignItems={"center"}
                        width={"100vw"}
                        height={"calc(100vh - 200px)"}
                    >
                        <CircularProgress size={50} />
                    </Box>
                ) : (
                    <div className='smallTable'>
                        <Grid item xs={12}>
                            <Paper className={classes.root}>
                                <TableContainer className={classes.container}>
                                    <Table
                                        className='thtdprsmall'
                                        aria-labelledby="tableTitle"
                                        aria-label="enhanced table">

                                        <EnhancedTableHead
                                            order={order}
                                            orderBy={orderBy}
                                            // onRequestSort={handleRequestSort}
                                            rowCount={users.length}
                                        />
                                        {
                                            users &&
                                                users.length > 0 ?
                                                <TableBody className="whitespace-nowrap">
                                                    {
                                                        users.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                            .map((item, index) => {
                                                                return (
                                                                    <TableRow
                                                                        hover
                                                                        tabIndex={-1}
                                                                        key={index}
                                                                        style={{ cursor: 'pointer' }}
                                                                    >
                                                                        <TableCell style={{ textAlign: "center" }} scope="item" width={'10px'}>
                                                                            <Typography variant={'body2'}>
                                                                                {(page * rowsPerPage) + index + 1}
                                                                            </Typography>
                                                                        </TableCell>
                                                                        <TableCell style={{ textAlign: "center" }}>
                                                                            {item.referral_code}
                                                                        </TableCell>
                                                                        <TableCell style={{ textAlign: "center" }}>
                                                                            {
                                                                                item.subscription_role == 1 ? 'Basic'
                                                                                : item.subscription_role == 3 ? 'Investor'
                                                                                : item.subscription_role == 5 ? 'Partnership'
                                                                                : "--"
                                                                            }
                                                                        </TableCell>
                                                                        <TableCell style={{ textAlign: "center" }}>
                                                                            {item.duration_in_days} Days
                                                                        </TableCell>
                                                                        <TableCell style={{ textAlign: "center" }}>
                                                                            <Typography variant={'body2'}>
                                                                                <Switch
                                                                                    checked={item.is_active == 1 ? true : false}
                                                                                    onChange={() => handleActiveStatus(item)}
                                                                                    color="primary"
                                                                                    name="checkedB"
                                                                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                                                                />
                                                                            </Typography>
                                                                        </TableCell>
                                                                        <TableCell style={{ textAlign: "center" }}>
                                                                            <Typography variant={'body2'} style={{ textAlign: "center" }} > {moment(item.created_on).format("DD-MMM-YYYY")}
                                                                            </Typography>
                                                                        </TableCell>
                                                                        <TableCell style={{}}>
                                                                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: 'center' }}>
                                                                                <Button onClick={(e) => onEditReferralCodeClick(e, item)} style={{ margin: 0, padding: 0 }}>
                                                                                    <Edit />
                                                                                </Button>
                                                                                <Button onClick={() => onDeleteReferralCodeClick(item)} style={{ margin: 0, padding: 0 }}>
                                                                                    <Delete />
                                                                                </Button>
                                                                            </div>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                );
                                                            })}
                                                </TableBody>
                                                :
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell colSpan={headCells.length}>
                                                            <Typography
                                                                style={{ textAlign: 'center', padding: '10px 0px' }}
                                                                noWrap
                                                                variant={'h4'}>No Records</Typography>
                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>
                                        }
                                    </Table>
                                </TableContainer>

                                <TablePagination
                                    rowsPerPageOptions={config.defaultRowsPerPage}
                                    component="div"
                                    count={users.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </Paper>
                        </Grid>
                    </div>
                )}
            </Grid>
        </>
    )
};

//TABLE HEADER CODE

const headCells = [
    { numeric: true, disablePadding: false, label: '#', sort: false, width: '50px', align: 'center' },
    { id: "referral_code", disablePadding: true, label: 'REFERRAL CODE', sort: false, align: "center" },
    { id: "subscription_role", disablePadding: false, label: "SUBSCRIPTION TYPE", sort: false, align: "center" },
    { id: "duration_in_days", numeric: true, disablePadding: false, label: "TIME DURATION", sort: false, align: "center" },
    { id: "is_active", disablePadding: false, label: "ACTIVE", sort: false, align: "center" },
    { id: "created_on", numeric: true, disablePadding: false, label: "REGISTERED DATE", sort: false, align: "center" },
    { id: "action", numeric: true, disablePadding: false, label: "ACTION", sort: false, align: "center" },
];

function EnhancedTableHead(props) {
    const {
        order,
        orderBy,
        onRequestSort,
    } = props
    const createSortHandler = property => event => {
        onRequestSort(event, property)
    }

    return (
        <TableHead>
            <TableRow >
                {headCells.map((headCell, index) => (
                    <TableCell
                        className='TablesRow'
                        align={headCell.align}
                        width={headCell.width}
                        key={index}
                        // align={headCell.align ? 'center' : headCell.numeric ? 'left' : 'right'}
                        padding={headCell.disablePadding ? 'none' : 'none'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        {headCell.sort ?
                            (<TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : 'asc'}
                                onClick={createSortHandler(headCell.id)}
                            >
                                <Typography
                                    noWrap
                                    weight={'medium'}
                                    variant={'body2'}
                                    style={{ textTransform: "uppercase" }}
                                >
                                    {headCell.label}
                                </Typography>
                            </TableSortLabel>
                            ) :
                            (<Typography
                                noWrap
                                weight={'medium'}
                                variant={'body2'}
                                style={{ textTransform: "uppercase" }}
                            >
                                {headCell.label}
                            </Typography>)
                        }
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>

    )
}


export default withRouter(ReferralCodeManagement)
